// The routes for the application. This module returns a function.
// `match` is match method of the Router
export default match => {
  match('', 'controllers/menu#show');
  match('menu(/:page)', 'controllers/menu#show');
  match('developer/accessibility', 'developer/controllers/accessibility#report');
  match('reload', 'controllers/reload#index');
  match('page', 'controllers/page#show');
  match(':module(/:activity)(/:page)', 'controllers/page#show');
};
